import { Component, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../../services/authentication.service';
import { Router } from '@angular/router';
import { DataCollectionValidation } from '../../page-validations/data-collection.validation';
import { AsyncPipe } from '@angular/common';
import { DesignSystemModule } from '@ukho/admiralty-angular';

@Component({
    selector: 'ukho-landing',
    standalone: true,
    imports: [AsyncPipe, DesignSystemModule],
    templateUrl: './landing.component.html',
    styleUrls: ['./landing.component.scss']
})
export class LandingComponent {
  public isAuthenticated!: Observable<boolean>;
  private readonly destroyRef = inject(DestroyRef);
  private readonly router = inject(Router);
  private readonly authenticationService = inject(AuthenticationService);

  constructor() {
    this.authenticationService.handleLoginNavigation(this.router).pipe(takeUntilDestroyed(this.destroyRef)).subscribe();
  }

  public login(): void {
    localStorage.clear();
    this.authenticationService.login();
  }

  public requestAccount(): void {
    this.router.navigate(['/request-an-account']);
  }

  protected readonly DataCollectionValidation = DataCollectionValidation;
}
